import React from "react";
import "../CSS_folder/HomePage.css";
import { Fade,Flip, Bounce, JackInTheBox,Rotate,Roll,Slide,Zoom } from "react-awesome-reveal";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import worldVideo from "../video.mp4";

function HomePage() {
  return (
    <div id="home" className="homepageContainer">
      <div className="videoContainer">
        <video src={worldVideo} autoPlay muted loop preload="auto" />

        <Fade delay={300}>
          <h3>Hi ! This is</h3>
        </Fade>

        <Fade delay={500}>
          <h1
            style={{
              fontSize: "50px",
              textShadow: "1px 6px 10px rgba(0, 0, 0, 0.5)",
              color: "rgb(255, 206, 9)",
            }}
          >
            Bruce Yim
          </h1>
        </Fade>

        <Fade delay={600}>
          <h2 className="homepageTitle" style={{ color: "#b5b5b5" }}>
            A Web Developer & Software Developer
          </h2>
        </Fade>

        <Fade delay={650}>
          <div className="homepageResume">
            <a
              href={process.env.PUBLIC_URL + "/Chilam_Yim_Resume_3.pdf"}
              download
            >
              <strong className="buttonText">DOWNLOAD MY RESUME HERE</strong>
            </a>
          </div>
        </Fade>

        {/* <Fade delay={700}>
          <a href="#about" style={{ textDecoration: "none" }}>
            <ArrowCircleDownIcon
              className="scroll-icon"
              style={{
                fontSize: 48,
                paddingTop: "30px",
                textDecoration: "none",
                color: "white",
              }}
            />
          </a>
        </Fade> */}
      </div>
    </div>
  );
}

export default HomePage;
